import * as mentorApi from '../../api/mentorApi';
import { entityKey } from '../ids';

/**
 * Canonical evaluation entity for workspace store.
 */
export function normalizeEvaluationEntity(evaluation) {
  if (!evaluation) return null;
  const base = mentorApi.normalizeEvaluation(evaluation);
  if (!base) return null;

  return {
    ...base,
    id: entityKey(base.id),
    sessionAuditorId: entityKey(base.sessionAuditorId),
    studentId: entityKey(base.studentId),
    approvedBy: base.approvedBy ? entityKey(base.approvedBy) : '',
  };
}